import { render, staticRenderFns } from "./HomeFeed.vue?vue&type=template&id=570a41cb&scoped=true&"
import script from "./HomeFeed.vue?vue&type=script&lang=js&"
export * from "./HomeFeed.vue?vue&type=script&lang=js&"
import style0 from "./HomeFeed.vue?vue&type=style&index=0&id=570a41cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570a41cb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('570a41cb')) {
      api.createRecord('570a41cb', component.options)
    } else {
      api.reload('570a41cb', component.options)
    }
    module.hot.accept("./HomeFeed.vue?vue&type=template&id=570a41cb&scoped=true&", function () {
      api.rerender('570a41cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/pages/TrendingFeeds/HomeFeed.vue"
export default component.exports